import Accounting from 'accounting';

export default {
    filters: {
        formatMoney(value) {
            return Accounting.formatMoney(value, { precision: 0 });
        },
    },
};
